import {$authHost} from './index';
import {approvalBody, bootstrapError, previewBody, readApplied, readPage, readPending, readPreview, readReadiness, recoveryBody, readRecovery} from '../utils/adminSkuBootstrap';

async function request(operation, body, validate) {
  let response;
  try {
    response = await $authHost.post(`api/catalog/sku-commerce-bootstrap/${operation}`, body, {headers: {'Cache-Control': 'no-store'}});
  } catch (error) {
    const status = error?.response?.status;
    // Transport/server failure cannot prove whether APPLY committed.
    if (operation === 'apply' && ![400, 403, 404, 409].includes(status)) throw bootstrapError('uncertain');
    throw bootstrapError(Number.isInteger(status) ? 'http' : 'network', Number.isInteger(status) ? status : null);
  }
  try {
    if (response?.status !== 200) throw bootstrapError();
    return validate(response.data);
  } catch {
    throw bootstrapError(operation === 'apply' ? 'uncertain' : 'contract');
  }
}
export async function previewSkuBootstrap(body = {}) {
  return request('preview', previewBody(body), readPreview);
}
export async function applySkuBootstrap(body, expected) {
  const checked = approvalBody(body); const pending = readPending(expected);
  if (JSON.stringify(checked) !== JSON.stringify(pending.approval)) throw bootstrapError();
  return request('apply', checked, value => readApplied(value, pending));
}
export async function getSkuBootstrapAllowlist(body, preview) {
  const p = readPreview(preview);
  if (!body || typeof body !== 'object' || Array.isArray(body) || Object.keys(body).some(key => !['runId', 'previewRevision', 'previewSha256', 'offset', 'limit'].includes(key))) throw bootstrapError();
  const {runId, previewRevision, previewSha256, offset = 0, limit = 100} = body;
  const binding = approvalBody({runId, previewRevision, previewSha256, confirm: true});
  if (runId !== p.runId || previewRevision !== p.previewRevision || previewSha256 !== p.previewSha256 ||
    !Number.isSafeInteger(offset) || offset < 0 || offset > p.allowlistCount || !Number.isSafeInteger(limit) || limit < 1 || limit > 100) throw bootstrapError();
  const cursor = {runId: binding.runId, previewRevision: binding.previewRevision, previewSha256: binding.previewSha256, offset, limit};
  return request('allowlist', cursor, value => readPage(value, p, offset, limit));
}
export async function getSkuBootstrapReadiness(body) {
  if (!body || Object.keys(body).length !== 1 || !Object.prototype.hasOwnProperty.call(body, 'runId')) throw bootstrapError();
  const checked = previewBody(body);
  return request('readiness', checked, value => readReadiness(value, checked.runId));
}
export async function recoverSkuBootstrap(body = {}) {
  const cursor = recoveryBody(body); return request('recovery', cursor, value => readRecovery(value, cursor));
}
